var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    fill: "#0099DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3945 46H23.7266V33.8516H10.543V46H5.89453V17.9922H10.543V29.7695H23.7266V17.9922H28.3945V46ZM35.3086 46V17.9922H43.3945C53.7201 17.9922 58.8828 22.543 58.8828 31.6445C58.8828 35.9674 57.4505 39.444 54.5859 42.0742C51.7214 44.6914 47.8802 46 43.0625 46H35.3086ZM39.9375 21.9375V42.0742H43.6484C46.9167 42.0742 49.4557 41.1758 51.2656 39.3789C53.0885 37.582 54 35.043 54 31.7617C54 25.2122 50.6081 21.9375 43.8242 21.9375H39.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdLogo);
export default __webpack_public_path__ + "static/media/hd_logo.a1cef205033720290a5e746d3c3dc4f8.svg";
export { ForwardRef as ReactComponent };